import { Slideshow } from '@archetype-themes/scripts/modules/slideshow'

document.addEventListener('DOMContentLoaded', function() {
  function initSlider(){
  // console.log('slideshow',Slideshow)
      var ele = document.querySelectorAll('.logo_slider')[0];
    // console.log('ele', document.querySelectorAll('.logo_slider')[0].getAttribute('data-autoplay'))
       var autoplayValue = ele?.getAttribute('data-autoplay');
       var autoPlay = (autoplayValue === 'true');
       var autoplayspeed = ele?.getAttribute('autoplay-speed');
       var autoplayspeedint = parseInt(autoplayspeed);
       var slidearrows = ele?.getAttribute('data-arrows');
       var showArrows = (slidearrows === 'true');
       const autoPlayVal = autoPlay ? autoplayspeedint : false;

    
       var defaults = {
        rtl: true,
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: showArrows ,
        autoPlay: autoPlayVal
      }
    console.log(defaults)
      var slide = new Flickity(ele, defaults);
      window.addEventListener('resize', function() {
        slide.resize();
      });

    if (autoPlay) {
      slide.on('scroll', function() {
        slide.playPlayer();
      });
    }

    if (autoPlay) {
       $('.logo_toolbar').on('click', function() {
        slide.playPlayer();
      });
    }
    
    // Define the goToSlide function outside of the event listener
         function goToSlide(index) {
              if (slide) {
                  const slideIndex = parseInt(index);
                  if (!isNaN(slideIndex)) {
                      slide.select(slideIndex);
                      console.log('Slide selected:', slideIndex);
                  } else {
                      console.error('Invalid slide index:', index);
                  }
              } else {
                  console.error('Flickity instance not available.');
              }
          }
          document.addEventListener('shopify:block:select', function(event) {
            const sectionId = event.detail.sectionId;
            const blockid = event.detail.blockId; 
            var index = document.querySelector('#'+blockid).getAttribute('data-index');
            console.log('current block',index)
            // var blockid = document.querySelector('.logo_toolbar').getAttribute('data-index');
            // console.log(blockid)
            goToSlide(index);
          });
       
  }
    
    initSlider();

      // Reinitialize sliders when Shopify sections are dynamically loaded
      document.addEventListener('shopify:section:load', function(event) {
          initSlider(); // Reinitialize to handle new sections
      });
  
})